import { Tooltip } from '@material-ui/core';
import { Badge } from 'components/bgp-overview/Badge';
import React from 'react';

export const OriginCard = ({ asn, name }: any) => {
  return (
    <div className="mr-4">
      <div className="font-bold my-3">
        <h1>Origin</h1>
      </div>
      <div className="w-40 h-20 flex flex-row flex-none rounded-xl bg-navy border-blue-light items-center">
        <Badge badgeColor="autonomousSystem" />
        <div className="flex flex-row p-4 w-full items-center text-left flex-wrap">
          <span className="w-full">AS {asn}</span>
          <Tooltip title={name}>
            <span className="overflow-ellipsis whitespace-nowrap overflow-hidden">{name}</span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
